/** Validate a Deploy action (rule.md §6, §9 — own home cell; Night may reinforce). */
import type { DeployAction } from "../types/action";
import { invalid, type ValidationResult, valid } from "../types/common";
import type { AugmentedWarState } from "../types/game-state";
import { legalDeployCells } from "../utils/deploy";
import { validateActionBudget, validateTurn } from "./shared";

export function validateDeploy(
  state: AugmentedWarState,
  action: DeployAction,
): ValidationResult {
  const turn = validateTurn(state, action.playerId);
  if (!turn.valid) return turn;
  const budget = validateActionBudget(state, "deploy");
  if (!budget.valid) return budget;

  const { to, playerId } = action;
  if (state.players[playerId].reserve < 1) {
    return invalid("No stacks left in reserve");
  }
  if (state.board[to]) {
    return invalid("Deploy target is occupied", { to });
  }
  if (!legalDeployCells(state, playerId).includes(to)) {
    return invalid("Deploy target must be your own empty home cell", { to });
  }
  return valid;
}
